import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { FormattedMessage } from 'translate';
import styled from 'styled-components';
import { Loader } from '../index';
import { GrayOutlineButton, PrimaryButton } from '../Buttons';
import SuccessTxModalStyles from './SuccessTxModal.styles';
import { colors } from '../../../styles/_vars';

const SuccessTxModalNoDataStyled = styled(SuccessTxModalStyles)`
  &.fetching-info {

    .loader-wrapper, .retry-interface-wrapper {
      width: 100%;
      min-width: 450px;
    }

    .loader-wrapper { padding: 50px; }
    
    .retry-interface-wrapper {

      .button-wrap button { margin-bottom: 0; }
      
      .message-box-wrapper.error {
        padding: 20px;
        font-size: 16px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        border-color: ${colors.red};
        color: ${colors.red};
  
        button {
          margin-top: 15px;
          max-width: fit-content;
        }
      }
    };
  }
  
  @media screen and (max-width: 550px) {
    &.fetching-info {
      display: flex;
      flex-direction: column;
      height: 100%;

      .success-title {
        margin-bottom: 0;

        h3.mobile-show { margin-bottom: 0; }
      }
    
      .loader-wrapper, .retry-interface-wrapper { min-width: unset; }
      
      .loader-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
  
        img { margin-bottom: 0; }
      }
      
      .retry-interface-wrapper {
        display: flex;
        height: 100%;
        align-items: center;
        flex-direction: column;
  
        .message-box-container {
          display: flex;
          height: 100%;
          align-items: center;
          
          .message-box-wrapper {
            height: fit-content;
            margin: 0;
            
            button {
              width: 100%;
              max-width: 100%;
            }
          }
        }
      }
    };
  }
`;

const SuccessTxModalNoData = ({
  title, isHistory, fetchingTxInfoError, fetchingTxInfo, transactionURL,
  fetchTxInfo,
}) => {
  const fetchTxInfoCallback = useCallback(() => {
    fetchTxInfo(0);
  }, []);

  return (
    <SuccessTxModalNoDataStyled
      className={clsx('success-step-modal fetching-info', { history: isHistory })}
    >
      <div className="success-title">
        <h3 className="mobile-show">{title}</h3>
      </div>

      {((!fetchingTxInfoError && fetchingTxInfo) || (!fetchingTxInfo && !fetchingTxInfoError)) && (
        <div className="loader-wrapper">
          <Loader type="secondary" className="tracking-loader" />
        </div>)}

      {fetchingTxInfoError && (
        <div className="retry-interface-wrapper">
          <div className="message-box-container">
            <div className="message-box-wrapper error">
              <FormattedMessage id="error.no_tx_info" />

              <GrayOutlineButton onClick={fetchTxInfoCallback} disabled={fetchingTxInfo}>
                <FormattedMessage id={fetchingTxInfo ? 'main.fetching' : 'main.retry'} />
              </GrayOutlineButton>
            </div>
          </div>

          <div className="button-wrap">
            <a href={transactionURL} target="_blank" rel="noopener noreferrer">
              <PrimaryButton>
                <FormattedMessage id="success_transaction_modal.view_in_explorer" />
              </PrimaryButton>
            </a>
          </div>
        </div>)}
    </SuccessTxModalNoDataStyled>
  );
};

SuccessTxModalNoData.propTypes = {
  title: PropTypes.string.isRequired,
  isHistory: PropTypes.bool.isRequired,
  fetchingTxInfoError: PropTypes.bool.isRequired,
  fetchingTxInfo: PropTypes.bool.isRequired,
  transactionURL: PropTypes.string.isRequired,
  fetchTxInfo: PropTypes.func.isRequired,
};

export default SuccessTxModalNoData;
